import React, { useEffect, useState } from "react";

/**
 * ColdStartSplash — full-page branded overlay shown only when the backend
 * is still cold-starting (i.e., /api/ takes more than ~2s to respond).
 * Once the API answers, the overlay fades out. It never shows if the
 * server was already warm — no unnecessary flash.
 */
export default function ColdStartSplash() {
  const [visible, setVisible] = useState(false);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const backend = process.env.REACT_APP_BACKEND_URL;
    if (!backend) return;
    let cancelled = false;
    let showTimer;
    // Show the splash only if the API takes more than 1500ms to answer.
    showTimer = setTimeout(() => { if (!cancelled) setVisible(true); }, 1500);
    fetch(`${backend}/api/`, { cache: "no-store", credentials: "omit" })
      .catch(() => null)
      .finally(() => {
        cancelled = true;
        clearTimeout(showTimer);
        setFading(true);
        setTimeout(() => setVisible(false), 350);
      });
    return () => {
      cancelled = true;
      clearTimeout(showTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="cold-start-splash"
      className={`fixed inset-0 z-[10000] bg-background flex flex-col items-center justify-center transition-opacity duration-300 ${
        fading ? "opacity-0" : "opacity-100"
      }`}
    >
      <div className="flex items-center gap-3 mb-6">
        <span className="inline-flex w-14 h-14 rounded-2xl bg-primary items-center justify-center animate-pulse">
          <span className="text-primary-foreground font-heading font-black text-3xl">R</span>
        </span>
        <span className="font-heading font-black text-3xl tracking-tight">
          <span className="text-primary">Ri</span>vendas
        </span>
      </div>
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <span className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: "0ms" }} />
        <span className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: "150ms" }} />
        <span className="w-2 h-2 rounded-full bg-primary animate-bounce" style={{ animationDelay: "300ms" }} />
      </div>
      <p className="mt-4 text-xs uppercase tracking-widest text-muted-foreground font-bold">
        Preparando o mercado reverso...
      </p>
    </div>
  );
}
